export default "__VITE_ASSET__0dml_DRh__"